import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { classes } from 'utils/parse';

const Button = React.forwardRef((props: any, ref) => {
	const { isLoading, isDisabled, children, ...restProps } = props;

	const renderButton = () => {
		return (
			<button
				{...restProps}
				title=""
				ref={ref}
				disabled={isDisabled}
				className={classes(
					'btn btn-primary',
					props.className || '',
					props.outline ? 'btn-outline' : '',
					props.clear ? 'btn-clear' : '',
					props.color ? 'btn-' + props.color : '',
					props.small ? 'btn-small' : '',
					props.block ? 'btn-block' : '',
					isLoading ? 'btn-loading' : ''
				)}
			>
				{isLoading ? (
					<span className="spinner" />
				) : (
					children
				)}
			</button>
		);
	}

	if (props.title) {
		return (
			<OverlayTrigger
				placement="top"
				overlay={
					<Tooltip id="tooltip-top">
						{props.title}
					</Tooltip>
				}
			>
				{renderButton()}
			</OverlayTrigger>
		)
	} else {
		return renderButton();
	}
});

export default Button;